// Lightbox galerie – nativní <dialog>, ovládání šipkami, Esc zavírá, fokus se vrací na miniaturu
(() => {
    const dialog = document.querySelector(".JS-lightbox");
    const links = [...document.querySelectorAll(".JS-gallery-item")];
    if (!dialog || !links.length || typeof dialog.showModal !== "function") return;

    const img = dialog.querySelector(".JS-lightbox-img");
    const caption = dialog.querySelector(".JS-lightbox-caption");
    const prev = dialog.querySelector(".JS-lightbox-prev");
    const next = dialog.querySelector(".JS-lightbox-next");
    let current = 0;
    let opener = null;

    const show = (index) => {
        current = (index + links.length) % links.length;
        const link = links[current];
        const thumb = link.querySelector("img");
        img.src = link.getAttribute("href");
        img.alt = thumb.alt;
        caption.textContent = `${current + 1} / ${links.length}`;
    };

    const single = links.length < 2;
    prev.hidden = single;
    next.hidden = single;

    links.forEach((link, index) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            opener = link;
            show(index);
            dialog.showModal();
            document.documentElement.classList.add("lightbox-open");
        });
    });

    prev.addEventListener("click", () => show(current - 1));
    next.addEventListener("click", () => show(current + 1));
    dialog.querySelector(".JS-lightbox-close").addEventListener("click", () => dialog.close());

    dialog.addEventListener("keydown", (e) => {
        if (single) return;
        if (e.key === "ArrowLeft") show(current - 1);
        if (e.key === "ArrowRight") show(current + 1);
    });

    // Klik mimo fotku zavře galerii
    dialog.addEventListener("click", (e) => {
        if (e.target === dialog || e.target.tagName === "FIGURE") dialog.close();
    });

    dialog.addEventListener("close", () => {
        document.documentElement.classList.remove("lightbox-open");
        if (opener) opener.focus();
    });
})();
